const en = {
  meta: {
    homeTitle: "HAROON TRADING 合同会社 — Automotive Excellence From Japan",
    homeDescription:
      "Carefully selected vehicles for Japan and the world. Vehicle sales, sourcing and export by HAROON TRADING 合同会社.",
    ogLocale: "en_US",
  },
  nav: {
    home: "Home",
    inventory: "Inventory",
    sourcing: "Sourcing",
    sell: "Sell Your Vehicle",
    export: "Export",
    company: "Company",
    contact: "Contact",
    privacy: "Privacy Policy",
    legal: "Legal Notice",
  },
  ui: {
    menu: "Menu",
    close: "Close",
    viewAll: "View all inventory",
    backHome: "Back to home",
    contactUs: "Contact us",
    toBeProvided: "To be provided",
    comingSoon: "Coming soon",
    error: "Vehicles could not be loaded right now.",
    empty: "New vehicles are being prepared.",
    scroll: "Scroll",
    explore: "Explore",
    company: "Company",
    legal: "Legal",
    contact: "Contact",
    email: "Email",
    phone: "Phone",
    viewDetails: "View details",
    notFoundTitle: "Page not found",
    notFoundBody: "The page you are looking for does not exist.",
  },
  hero: {
    brand: "HAROON TRADING",
    title: "Automotive Excellence From Japan.",
    subtitle: "Carefully selected vehicles for Japan and the world.",
    ctaInventory: "Explore Inventory",
    ctaSourcing: "Source a Vehicle",
  },
  featured: { eyebrow: "Featured", title: "Selected vehicles" },
  latest: { eyebrow: "Latest Inventory", title: "Recently arrived" },
  sourcing: {
    eyebrow: "Vehicle Sourcing",
    title: "The car you want, found in Japan.",
    body: "Tell us what you are looking for. We search the Japanese market and come back with suitable candidates.",
    steps: [
      { title: "Share your brief", body: "Make, model, year, specification and budget." },
      { title: "We search the market", body: "We look across Japan for vehicles that match." },
      { title: "Review and decide", body: "We report details and condition for your decision." },
    ],
    cta: "Request sourcing",
  },
  why: {
    eyebrow: "Why Haroon Trading",
    title: "Chosen with care. Presented with clarity.",
    items: [
      { title: "Careful selection", body: "Each vehicle is chosen for its history, condition and specification." },
      { title: "Clear information", body: "Specifications, repair history and condition, stated plainly in English and Japanese." },
      { title: "Japan and worldwide", body: "Domestic sales and export, handled by one team." },
    ],
  },
  export: {
    eyebrow: "Japan & Worldwide",
    title: "From Japan, to the world.",
    japanTitle: "Japan",
    japanBody: "Sales and delivery for customers within Japan.",
    worldTitle: "Worldwide",
    worldBody: "Export documentation and shipping arrangements for buyers overseas.",
    cta: "Export enquiries",
  },
  company: {
    eyebrow: "Company",
    title: "HAROON TRADING 合同会社",
    body: "A Japan-based company specialising in vehicle sales, sourcing and export.",
    cta: "Company profile",
    profileTitle: "Company Profile",
    rows: {
      name: "Company Name",
      corporateNumber: "Corporate Number",
      representative: "Representative Member",
      established: "Established",
      capital: "Capital",
      address: "Head Office",
      phone: "Telephone",
      business: "Business Activities",
      license: "Secondhand Dealer Licence",
      website: "Website",
    },
  },
  contactCta: {
    eyebrow: "Contact",
    title: "Start a conversation.",
    body: "Tell us what you are looking for. Enquiries are welcome in English or Japanese.",
    cta: "Contact us",
  },
  vehicle: {
    ask: "Price on Request",
    detailsSoon: "The full vehicle page is being prepared.",
    notFound: "This vehicle is not currently listed.",
    demo: "Demo listing",
  },
  shell: {
    title: "This page is being prepared.",
    body: "It will be available soon. Thank you for your patience.",
  },
  pages: {
    inventory: { title: "Inventory", description: "Browse vehicles available from HAROON TRADING in Japan." },
    sold: { title: "Sold Vehicles", description: "Vehicles recently sold by HAROON TRADING. We can source a similar one for you." },
    sourcing: { title: "Vehicle Sourcing", description: "Have HAROON TRADING find the right vehicle for you in Japan." },
    sell: { title: "Sell Your Vehicle", description: "Sell your vehicle to HAROON TRADING." },
    export: { title: "Export", description: "Vehicle export from Japan to buyers worldwide." },
    company: { title: "Company Profile", description: "Company profile of HAROON TRADING 合同会社." },
    contact: { title: "Contact", description: "Contact HAROON TRADING 合同会社." },
    privacy: { title: "Privacy Policy", description: "Privacy policy of HAROON TRADING 合同会社." },
    legal: {
      title: "Legal Notice (Specified Commercial Transactions Act)",
      description: "Disclosure under the Act on Specified Commercial Transactions.",
    },
  },
  labels: {
    stockId: "Stock No.",
    make: "Make",
    model: "Model",
    grade: "Grade",
    modelYear: "Model Year",
    registrationYear: "First Registration",
    price: "Price",
    mileage: "Mileage",
    bodyType: "Body Type",
    chassisNumber: "Chassis No.",
    modelCode: "Model Code",
    engine: "Engine",
    displacement: "Displacement",
    fuel: "Fuel",
    transmission: "Transmission",
    drivetrain: "Drivetrain",
    aspiration: "Aspiration",
    steering: "Steering",
    doors: "Doors",
    seats: "Seats",
    exteriorColor: "Exterior Colour",
    interiorColor: "Interior Colour",
    dimensions: "Dimensions (L × W × H)",
    shakenExpiry: "Shaken Expiry",
    repairHistory: "Repair History",
    status: "Status",
    market: "Market",
    features: "Features",
    condition: "Condition",
  },
  enums: {
    fuel_type: { petrol: "Petrol", diesel: "Diesel", hybrid: "Hybrid", plug_in_hybrid: "Plug-in Hybrid", electric: "Electric" },
    transmission: { automatic: "Automatic", manual: "Manual", cvt: "CVT", dct: "Dual-Clutch" },
    drivetrain: { "2wd": "2WD", "4wd": "4WD", awd: "AWD", fwd: "FWD", rwd: "RWD" },
    steering: { right: "Right-hand drive", left: "Left-hand drive" },
    repair_history: { none: "None", yes: "Yes", unknown: "Unknown" },
    status: { draft: "Draft", available: "Available", reserved: "Reserved", sold: "Sold" },
    market: { japan: "Japan", export: "Export", both: "Japan & Export" },
    body_type: { suv: "SUV", sedan: "Sedan", coupe: "Coupe", hatchback: "Hatchback", wagon: "Wagon", minivan: "Minivan", convertible: "Convertible", pickup: "Pickup", van: "Van", truck: "Truck", kei: "Kei Car", commercial: "Commercial" },
    condition_grade: { excellent: "Excellent", very_good: "Very good", good: "Good", fair: "Fair", poor: "Poor" },
  },
  footer: { tagline: "Vehicle sales, sourcing and export from Japan." },
  inventory: {
    tabAvailable: "Available",
    tabSold: "Sold",
    scopeNav: "Inventory sections",
    vehicles: "Vehicles",
    showing: "Showing {shown} of {total}",
    loadMore: "Load more",
    emptyLabel: "No results",
    emptyTitle: "No vehicles match your filters.",
    emptyBody: "Try widening your search or clearing some filters.",
    clearFilters: "Clear filters",
    soonLabel: "Inventory",
    soonTitle: "New arrivals coming soon.",
    soonBody: "We are preparing our first vehicles. Looking for something specific? We can source it for you in Japan.",
    soonSourcing: "Request sourcing",
    errorTitle: "Inventory could not be loaded.",
    errorBody: "Please check your connection and try again.",
    retry: "Try again",
  },
  filters: {
    filters: "Filters",
    make: "Make",
    model: "Model",
    allMakes: "All makes",
    allModels: "All models",
    selectMakeFirst: "Select a make first",
    year: "Year",
    from: "From",
    to: "To",
    price: "Price",
    min: "Min",
    max: "Max",
    mileage: "Mileage",
    upTo: "Up to {value}",
    any: "Any",
    body: "Body Type",
    more: "More",
    fuel: "Fuel",
    transmission: "Transmission",
    drivetrain: "Drivetrain",
    availability: "Availability",
    includeSold: "Include sold vehicles",
    apply: "Apply",
    clearAll: "Clear All",
    close: "Close filters",
    sort: "Sort",
    sorts: {
      newest: "Newest",
      price_asc: "Price: low to high",
      price_desc: "Price: high to low",
      sold_recent: "Recently sold",
      oldest: "Oldest listings",
      updated: "Recently updated",
      year_desc: "Year: newest first",
      year_asc: "Year: oldest first",
      mileage_asc: "Mileage: lowest first",
      mileage_desc: "Mileage: highest first",
      make_az: "Make: A–Z",
      make_za: "Make: Z–A",
    },
    moreFilters: "More filters",
    selectedCount: "{n} selected",
    showResults: "Show {n} results",
    clearAll: "Clear all",
    remove: "Remove filter",
    displacement: "Engine size",
    aspiration: "Aspiration",
    exteriorColor: "Exterior colour",
    market: "Market",
    equipment: "Equipment",
    searchEquipment: "Search equipment",
    quick4wd: "4WD / AWD",
    quickTurbo: "Turbo",
  },
  detail: {
    overview: "Overview",
    specifications: "Specifications",
    features: "Features & Equipment",
    condition: "Vehicle Condition",
    related: "Related Vehicles",
    knownImperfections: "Known Imperfections",
    conditionLabels: { exterior: "Exterior", interior: "Interior", mechanical: "Mechanical", wheels: "Wheels", tires: "Tyres" },
    conditionDisclaimer: "Condition information is provided for reference only and is not an inspection report or guarantee.",
    inspected: "Condition reviewed by HAROON TRADING.",
    enquire: "Enquire",
    whatsapp: "WhatsApp",
    line: "LINE",
    lineAdd: "Add us on LINE",
    share: "Share",
    linkCopied: "Link copied",
    viewSimilar: "View similar vehicles",
    findSimilar: "Find a Similar Vehicle",
    viewAvailable: "View Available Vehicles",
    soldNote: "This vehicle has been sold.",
    reservedNote: "This vehicle is currently reserved. You are still welcome to contact us.",
    availability: { japan: "Available in Japan", export: "Available for Export", both: "Japan & Export" },
    noImages: "No images available",
    imageUnavailable: "Image unavailable",
    previous: "Previous image",
    next: "Next image",
    openGallery: "Open full-screen gallery",
    viewPhoto: "View photo",
    notFoundTitle: "Vehicle not found",
    notFoundBody: "This vehicle is no longer listed, or the link may be incorrect.",
    backToInventory: "Back to inventory",
    whatsappMessage: "Hello, I am interested in the {title} (Stock No. {stock}). {url}",
  },
  inquiry: {
    title: "Vehicle Enquiry",
    vehicle: "Vehicle",
    name: "Name",
    country: "Country",
    selectCountry: "Select a country",
    email: "Email",
    phone: "WhatsApp / Phone",
    port: "Destination Port",
    optional: "Optional",
    message: "Message",
    messagePlaceholder: "Questions, requests or preferred contact times",
    consentPre: "I agree to the handling of my information in accordance with the ",
    consentLink: "Privacy Policy",
    consentPost: ".",
    submit: "Send enquiry",
    sending: "Sending",
    successTitle: "Thank you.",
    successBody: "Your enquiry has been received. We will be in touch shortly.",
    close: "Close",
    errors: {
      required: "This field is required.",
      email: "Please enter a valid email address.",
      consent: "Please agree to the Privacy Policy to continue.",
      tooLong: "This entry is too long.",
      rate: "Too many enquiries, please try again shortly.",
      tooFast: "Please review your details and send again.",
      invalid: "Please check the highlighted fields and try again.",
      unavailable: "This vehicle is no longer available for enquiry.",
      generic: "Your enquiry could not be sent. Please try again.",
    },
  },
  price: {
    totalLabel: "Total Price (incl. fees)", vehiclePrice: "Vehicle Price", exclTax: "(excl. tax)", inclTax: "(incl. tax)", vehiclePriceIncl: "Vehicle price (incl. tax)", vehiclePriceExcl: "Vehicle price (excl. tax)", miscFees: "Misc. Fees", conditions: "Price conditions",
    price: "Price", shipping: "Shipping quoted on request",
    exportTaxNote: "Consumption tax treatment for qualifying export transactions may differ. Please contact us for details.",
  },
  form: {
    next: "What happens next", nextSteps: ["We review every request personally.", "We reply by email with options or questions.", "Nothing is binding until you confirm."],
    optional: "Optional", sending: "Sending", again: "Send another request",
    successTitle: "Thank you.", successBody: "Your request has been received. We will be in touch shortly.",
    consentPre: "I agree to the handling of my information in accordance with the ", consentLink: "Privacy Policy", consentPost: ".",
    name: "Name", email: "Email", phone: "WhatsApp / Phone", message: "Message", country: "Country", selectCountry: "Select a country", searchCountry: "Search countries", noCountry: "No country found",
    port: "Destination Port", yourDetails: "Your details",
    errors: {
      required: "This field is required.", email: "Please enter a valid email address.", consent: "Please agree to the Privacy Policy to continue.",
      tooLong: "This entry is too long.", number: "Please enter a valid number.", yearOrder: "“To” must be the same as or later than “From”.",
      rate: "Too many requests, please try again shortly.", tooFast: "Please review your details and send again.",
      invalid: "Please check the highlighted fields and try again.", storage: "Photos could not be uploaded right now. Please try again.",
      generic: "Your request could not be sent. Please try again.",
    },
  },
  sourcingPage: {
    eyebrow: "Vehicle Sourcing", title: "Tell us what you are looking for",
    intro: "Share the vehicle and conditions you have in mind. We search auctions, dealers and our own network in Japan and reply with suitable options.",
    vehicle: "Vehicle", make: "Make", model: "Model", yearFrom: "Year from", yearTo: "Year to", budget: "Budget (JPY)", mileageMax: "Maximum mileage (km)",
    delivery: "Delivery", destination: "Where will the vehicle be used?", japan: "Within Japan", export: "Export from Japan",
    messagePlaceholder: "Preferred colour, grade, options or anything else we should know", submit: "Send sourcing request",
  },
  sellPage: {
    eyebrow: "Sell Your Vehicle", title: "Sell your vehicle to us",
    intro: "Send us the details and a few photos. We review every vehicle individually and contact you with our assessment.",
    vehicle: "Vehicle", make: "Make", model: "Model", grade: "Grade", year: "Year", mileage: "Mileage (km)", chassis: "Chassis no. / model code",
    conditionNotes: "Condition notes", conditionPlaceholder: "Accident history, repairs, scratches, modifications, service records",
    askingPrice: "Asking price (JPY)", location: "Location / prefecture", photos: "Photos",
    photosHint: "Up to 10 photos · JPEG, PNG, WebP or HEIC · max 25 MB each", addPhotos: "Add photos", remove: "Remove",
    photosTooMany: "You can attach up to 10 photos.", photosType: "Some files were skipped: only JPEG, PNG, WebP or HEIC up to 25 MB are accepted.",
    submit: "Send vehicle details",
  },
  contactPage: {
    eyebrow: "Contact", title: "Get in touch", intro: "Questions about a vehicle, sourcing, export or selling — send us a message and we will reply by email.",
    subject: "Subject", details: "Contact details", address: "Address", map: "Map", submit: "Send message",
  },
  exportPage: {
    eyebrow: "Export", title: "Exporting a vehicle from Japan", process: "How it works", documents: "Documents", shipping: "Shipping methods",
    examples: "Example markets",
    eligibilityNote: "Import eligibility, age limits, steering requirements, inspection, duties and taxes, and shipping availability depend on the destination and the vehicle. Contact us with your destination country and port and we will confirm what applies.",
    regions: "Destinations", regionsEmpty: "Please contact us to confirm arrangements for your destination.",
    ctaTitle: "Start with an enquiry", ctaBody: "Tell us the vehicle you are interested in or what you are looking for, and your destination.",
    ctaSourcing: "Request sourcing", ctaContact: "Contact us",
  },
  legalPage: { preparingTitle: "Being prepared", preparingBody: "This page is being prepared and will be published shortly." },
};

export default en;
